export const mockSelects = {
  region: [
    { name: 'METROPOLITANA', value: 'METROPOLITANA' },
    { name: 'VALPARAISO', value: 'VALPARAISO' },
    { name: 'LGB O’HIGGINS', value: 'LGB O’HIGGINS' },
  ],
  flow: [
    { name: 'Medium Ticket', value: 'MT' },
    { name: 'Mini Ticket', value: 'MM' }
  ],
  clients: [
    //{ name: 'Easy', value: 'EASY'},
    { name: 'Falabella', value: 'FALABELLA' },
    { name: 'Falabella GSC', value: 'FALABELLA GSC' },
    { name: 'Paris', value: 'PARIS' },
    { name: 'Ripley', value: 'RIPLEY' },
    { name: 'Nclientes', value: 'NCLIENTES' }
  ],
  origins: [
    { name: 'Sorting Regular', value: 'SORTING REGULAR' },
    { name: 'Sorting SDD', value: 'SORTING SDD' },
    { name: 'Despacho Regular', value: 'DESPACHO REGULAR' },
    { name: 'Despacho SDD', value: 'DESPACHO SDD' },
    { name: 'Devolucion', value: 'DEVOLUCIÓN' },
    { name: 'Logistica Inversa', value: 'LOGISTICA INVERSA' },
    { name: 'Ruta', value: 'RUTA' },
    { name: 'VAS', value: 'VAS'},
    { name: 'Sin Información', value: 'SIN INFORMACION'}
  ],
  destinations: [
    { name: 'Asignación Manual', value: 'ASIGNACION MANUAL' },
    { name: 'En Proceso', value: 'EN PROCESO' },
    { name: 'Repite', value: 'REPITE' },
    { name: 'Pre-Logistica Inversa', value: 'PRE-LOGISTICA INVERSA' },
    { name: 'Merma', value: 'MERMA' },
    { name: 'Sin Información', value: 'SIN INFORMACION' },
    { name: 'Por despachar en bodega', value: 'POR DESPACHAR EN BODEGA' },
    { name: 'Despachado en bodega', value: 'DESPACHADO EN BODEGA' },
    { name: 'Devuelto en ruta', value: 'DEVUELTO EN RUTA' },
    { name: 'Devuelto a cliente', value: 'DEVUELTO A CLIENTE' },
    { name: 'VAS', value: 'VAS' }
  ],
  reasons: [
    {name: 'Guía incompleta', value: 'GUIA INCOMPLETA'},
    {name: 'Sin moradores', value: 'SIN MORADORES'},
    {name: 'No se encuentra dirección', value: 'NO SE ENCUENTRA DIRECCION'},
    {name: 'Domicilio no corresponde', value: 'DOMICILIO NO CORRESPONDE'},
    {name: 'Anulará, cambiado', value: 'ANULARA, CAMBIADO'},
    {name: 'Fuera de horario', value: 'FUERA DE HORARIO'},
    {name: 'Fuera de ruta', value: 'FUERA DE RUTA'},
    {name: 'Fuera de cobertura', value: 'FUERA DE COBERTURA'},
    {name: 'Zona intransitable', value: 'ZONA INTRANSITABLE'},
    {name: 'Detención de entrega', value: 'DETENCION DE ENTREGA'},
    {name: 'Incidente en ruta', value: 'INCIDENTE EN RUTA'},
    {name: 'Duplicado', value: 'DUPLICADO'},
    {name: 'Recogido exitoso', value: 'RECOGIDO EXITOSO'},
    {name: 'Mermado; operativo', value: 'MERMADO, OPERATIVO'},
    {name: 'Falsa entrega', value: 'FALSA ENTREGA'},
    {name: 'Discrepancia sobrante', value: 'DISCREPANCIA SOBRANTE'},
    {name: 'Comuna errónea', value: 'COMUNA ERRONEA'},
    {name: 'Dirección errónea', value: 'DIRECCION ERRONEA'},
    {name: 'Error de bin', value: 'ERROR DE BIN'},
    {name: 'Sobredimensionado', value: 'SOBREDIMENSIONADO'},
    {name: 'Sin información sistémica', value: 'SIN INFORMACION SISTEMICA'},
    {name: 'Empaque dañado', value: 'EMPAQUE DAÑADO'},
    {name: 'Otro', value: 'OTRO'}
  ]
}
